'use strict';

const sptOptionSwitch = $('.spt-option-switch');
const commonHelpers = require('../helpers/commonHelpers');
const cart = require('./cart');

function initCartUpdateListener() {
    $('body').on('cart:update', function (e, data) {
        updateSptDataInCart(data);
    });
}

/**
 *
 */
function init(cart) {
    initSwitchSelector();
    initTermsAndConditionsCheck();
    termsAndConditionsCheck();
    initCartUpdateListener();
};

function updateSptDataInCart(basket) {
    if (!basket) {
        return;
    }

    let basketItems = basket.basket ? basket.basket.items : basket.items;
    let basketObj = basket.basket ? basket.basket : basket;

    // Update SPT total price in cart summary
    if(basketObj.sptInsuranceTotal > 0) {
        $('.spt-cart-insurance-row').show();
        $(`.spt-cart-insurance-row .sub-total`).empty().text(basketObj.sptInsuranceTotalFormatted);
    } else {
        $('.spt-cart-insurance-row').hide();
    }

    basketItems.forEach(function (item) {
        let sptInsuranceToApply = null;

        item.options.forEach(function(option) {
            if (option.ID === 'SPT') {
                sptInsuranceToApply = option;
            }  
        });

        if (sptInsuranceToApply) {

                sptInsuranceToApply = item.sptInsuranceToApply;
                let optionPrice = parseInt(sptInsuranceToApply.priceValue) * parseInt(quantity);
                $(`.uuid-${linteItemId} .spt-insurance-price span`).data('spt-insurance-price', optionPrice);
                $(`.uuid-${linteItemId} .spt-insurance-price span`).empty().text(commonHelpers.formatMoneyToClp(optionPrice));

                $("input").find(`[data-line-item-id='${linteItemId}']`).data('spt-id', sptInsuranceToApply.id);            

        }
    });
}

function sendSptDataToBackend(linteItemId, selectedSpt, sptUrlAction) {
    $.spinner().start();

    let form = {
        sptId: selectedSpt,
        itemId: linteItemId
    };

    $.ajax({
        url: sptUrlAction,
        method: 'POST',
        data: form,
        success: function (data) {
            $.spinner().stop();

            if(data.success) {
                cart.updateCartTotals(data.basket);
                $('body').trigger('cart:update', data);
                updateSptDataInCart(data.basket);
            }
        },
        error: function (err) {
            $.spinner().stop();
        }
   });
}

function sendUpdateSptTermsAndConditionsBackend(status, sptUrlAction) {
    $.spinner().start();

    let form = {
        status: status
    };

    $.ajax({
        url: sptUrlAction,
        method: 'POST',
        data: form,
        success: function (data) {
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
        }
   });
}

function initTermsAndConditionsCheck() {
    const $sptTermsAndConditonsCart = $('#spttermsandconditionscart');

    $('body').on('spt:acceptTermsAndCondition', function() {
        const $spt = $('#spttermsandconditionscart');
        const checked = $spt.prop("checked");
        sendUpdateSptTermsAndConditionsBackend(checked, $sptTermsAndConditonsCart.data('spt-action')); 
    });

    $sptTermsAndConditonsCart.on('change', function() {
        const $spt = $('#spttermsandconditionscart');
        const checked = $spt.prop("checked");

        if (!checked) {
            sendUpdateSptTermsAndConditionsBackend(checked, $(this).data('spt-action'));
        }
    });
}

function termsAndConditionsCheck() {
    const $sptSelectors = $(".spt-option-switch");
    let areAllSelectorsUnSelected = true;
    const $sptTermsAndConditonsCart = $('#spttermsandconditionscart');

    $sptSelectors.each(function() {
        if ($(this).is(':checked')) {
            areAllSelectorsUnSelected = false;
        }
    });

    if (areAllSelectorsUnSelected) {
        $sptTermsAndConditonsCart.parent().addClass('d-none');
    } else {
        $sptTermsAndConditonsCart.parent().removeClass('d-none');
    }

    const termsAndConditonsCart = $('#termsandconditionscart');
    const acceptanceConditionsCart = termsAndConditonsCart.prop('checked');
    const acceptanceSpt =  !$sptTermsAndConditonsCart.is(":visible") || ($sptTermsAndConditonsCart.prop('checked') && $sptTermsAndConditonsCart.is(":visible"));

    if (!acceptanceSpt || !acceptanceConditionsCart) {
        termsAndConditonsCart.parents('.checkout-continue').find('.checkout-btn').addClass('disabled');
    } else {
        termsAndConditonsCart.parents('.checkout-continue').find('.checkout-btn').removeClass('disabled');
    }

    
}

function initSwitchSelector() {
    sptOptionSwitch.on('change', function() {
        let lineItemId = $(this).data('line-item-id');
        let selectedSpt = $(this).data('spt-id');
        let sptUrlAction = $(this).data('spt-action');

        termsAndConditionsCheck();

        if ($(this).prop("checked")) {
            // Send data to backend
            sendSptDataToBackend(lineItemId, selectedSpt, sptUrlAction);
        } else {
            // Remove from total
            sendSptDataToBackend(lineItemId, 'no-spt', sptUrlAction);
        }
    });
}

module.exports = function (cart) {
    init(cart);
};
